import { FrequencyCode, EndType } from '../webgiving-generated';
import { GiftType, IWebGivingCommonPaymentState, IWebGivingRecurringPaymentState } from '../webgiving-payment-state';
import { PagePaymentSuccessViewModel } from '../pages/page-payment-success/page-payment-success-view-model';
import { IWebGivingSagaContext } from '../webgiving-saga';

export function configureRecurringSuggestionInformation(context: IWebGivingSagaContext, isBackJourney: boolean) {
	const { mainViewModel, appState } = context;
	const { currentPageViewModel } = mainViewModel;
	const { data } = (currentPageViewModel as PagePaymentSuccessViewModel);
	const { recurringInfo } = data;
	const recurringAppState = appState.paymentState as IWebGivingCommonPaymentState & IWebGivingRecurringPaymentState;
	if (!isBackJourney) {
		if (recurringInfo && recurringInfo.Frequency) {
			appState.recurringSuggestion = recurringInfo;
			appState.fromRecurringSuggestion = true;
			recurringAppState.amount = recurringInfo.Amount;
			recurringAppState.giftType = GiftType.Recurring;
			recurringAppState.recurringInfo = {
				frequency: recurringInfo.Frequency,
				startDate: new Date(Date.parse((recurringInfo.StartOnDate || new Date()).toString())),	// Annoyingly, it is a string not a date, but TS thinks it's a Date already.
				endType: EndType.Never,
			};
		}
	} else {
		data.recurringInfo = appState.recurringSuggestion;
	}
}

export function handleSetRecurringSuggestion(context: IWebGivingSagaContext,
	postStatsData: (context: IWebGivingSagaContext, additionalData: { [key: string]: string } | null) => void) {
	let additionalData: { [key: string]: string } = {};
	const { recurringInfo } = (context.mainViewModel.currentPageViewModel as PagePaymentSuccessViewModel).data;
	if (recurringInfo && recurringInfo.Frequency) {
		additionalData['UserAction'] = 'RecurringSuggestion';
		additionalData['Amount'] = recurringInfo.Amount.toString();
		additionalData['Frequency'] = FrequencyCode[recurringInfo.Frequency].toString();
		additionalData['StartDate'] = new Date(recurringInfo.StartOnDate && recurringInfo.StartOnDate.toString() || '').toString();
		additionalData['FundId'] = recurringInfo.FundKey;
		postStatsData(context, additionalData);
	}
}

export function handleSetRecurringSuggestionSuccess(context: IWebGivingSagaContext,
	postStatsData: (context: IWebGivingSagaContext, additionalData: { [key: string]: string } | null) => void) {
	let additionalData: { [key: string]: string } = {};
	const { recurringSuggestion, paymentState, previousPaymentThankYouPageDetails } = context.appState;
	if (recurringSuggestion && recurringSuggestion.Frequency && previousPaymentThankYouPageDetails) {
		additionalData['UserAction'] = 'RecurringSuggestionSuccess';
		additionalData['SuggestedAmount'] = recurringSuggestion.Amount.toString();
		additionalData['SuggestedFundId'] = recurringSuggestion.FundKey;
		additionalData['SuggestedFrequency'] = FrequencyCode[recurringSuggestion.Frequency].toString();
		additionalData['SuggestedStartDate'] = new Date(recurringSuggestion.StartOnDate && recurringSuggestion.StartOnDate.toString() || '').toString();
		additionalData['ActualGiftType'] = GiftType[paymentState.giftType].toString();
		additionalData['ActualAmount'] = paymentState.amount.toString();
		additionalData['ActualFundId'] = paymentState.fundKey.toString();
		switch (paymentState.giftType) {
			case GiftType.Recurring:
				const recurringAppState = paymentState as IWebGivingCommonPaymentState & IWebGivingRecurringPaymentState;
				const { recurringInfo } = recurringAppState;
				additionalData['ActualFrequency'] = (recurringInfo.frequency && FrequencyCode[recurringInfo.frequency] || '').toString();
				additionalData['ActualStartDate'] = new Date(recurringInfo.startDate && recurringInfo.startDate.toString() || '').toString();
				break;
			case GiftType.OneTime:
				additionalData['ActualFrequency'] = '';
				additionalData['ActualStartDate'] = new Date().toString();
				break;
		}
		postStatsData(context, additionalData);
		context.appState.recurringSuggestion = null;
	}
}
